import { Truck, Warehouse } from 'lucide-react';
import { HubPageLayout, SettingsRowDef } from './HubPageLayout';

export function OperationsHubPage() {
  const rows: SettingsRowDef[] = [
    {
      id: 'manage-warehouses',
      label: 'Manage Warehouses',
      desc: 'Warehouse locations used for dispatch and travel time calculations.',
      icon: Warehouse,
      path: '/admin/operations/manage-warehouses',
    },
    {
      id: 'manage-fleet',
      label: 'Manage Fleet',
      desc: 'Trucks, capacity, and fleet availability.',
      icon: Truck,
      path: '/admin/operations/manage-fleet',
    },
  ];

  return (
    <HubPageLayout
      title="Operations"
      subtitle="Fleet, dispatch, and job management."
      rows={rows}
    />
  );
}
